export default __webpack_public_path__ + "static/media/empty-state-metrics.06aa3c35.svg";